import React,{useState,useEffect} from 'react';
import { Routes, Route,useLocation } from 'react-router-dom';

import Header from "@src/common/Header";
import Footer from "@src/common/Footer";
import PrivateRoute from './PrivateRoute';
import Login from '../view/auth/Login.js';
import LeadList from '@src/lead/LeadList';
import LeadDetail from '../../src/lead/LeadDetail';
import Dashboard from '../dasboard/dashboard';
import { getPublicKey } from '@src/store/slices/encryption';



const AppRouter = () => {
    const location = useLocation()
    let currentPath = location.pathname;
    // const loadRoutes=true;
    const [loadRoutes, setLoadRoutes] = useState(true)

    useEffect(()=>{
        getPublicKey().then((res: any)=> {
            if(res?.data) setLoadRoutes(true)
        })

    },[])
    
    return (
        <>
            {
                !["/", "", "/login", "/delete/account" ,"/not-found"].includes(currentPath) && <Header />
            }
            { loadRoutes && <Routes>

                <Route path="/" element={<PrivateRoute components={Login} accessPageId="23"  accessType = "isVisible"/>} />  
                <Route path="/login" element={<PrivateRoute components={Login} accessPageId="23"  accessType = "isVisible"/>} /> 
                <Route path="/dashboard" element={<PrivateRoute components={Dashboard} accessPageId="24"  accessType = "isVisible"/>} />             
                <Route path="/lead-list" element={<PrivateRoute components={LeadList} accessPageId="25"  accessType = "isVisible"/>}/>       
                <Route path="/lead-details/:id" element={<PrivateRoute components={LeadDetail} accessPageId="29"  accessType = "isVisible"/>} />  
            </Routes>
            }

            {
                !["/", "", "/login", "/delete/account" ,"/not-found"].includes(currentPath) && <Footer />
            }
        </>
    );
}



export default AppRouter;